import { IndicatorBars } from 'interfaces/IndicatorFieldsHierarchy';
import React, { createContext, useState } from 'react';

type ColumnBarInput = {
  name: string;
  color: string;
};

type IndicatorsContextType = {
  attData: boolean;
  setAttData: (value: boolean) => void;
  elementNamesMultiple: IndicatorBars[];
  setElementNamesMultiple: (elementNamesMultiple: IndicatorBars[]) => void;
  xAxisTitleMultiple: string;
  setXAxisTitleMultiple: (xAxisTitleMultiple: string) => void;
  yAxisTitleMultiple: string;
  setYAxisTitleMultiple: (yAxisTitleMultiple: string) => void;
  inputNameBarsMultiple: string;
  setInputNameBarsMultiple: (inputNameBarsMultiple: string) => void;
  inputValuesColumnBars: ColumnBarInput[];
  setInputValuesColumnBars: (inputValuesColumnBars: ColumnBarInput[]) => void;
  inputNameColumnGraphic: string;
  setInputNameColumnGraphic: (inputNameColumnGraphic: string) => void;
  xAxisTitleColumn: string;
  setXAxisTitleColumn: (xAxisTitleColumn: string) => void;
  yAxisTitleColumn: string;
  setYAxisTitleColumn: (yAxisTitleColumn: string) => void;
  menu: 'service' | 'work';
  setMenu: (menu: 'service' | 'work') => void;
};

const defaultValues: IndicatorsContextType = {
  attData: false,
  setAttData: () => {},
  elementNamesMultiple: [
    { id: null, name: 'Elemento 1', color: '#000000', value: 0 },
  ],
  setElementNamesMultiple: () => {},
  xAxisTitleMultiple: '',
  setXAxisTitleMultiple: () => {},
  yAxisTitleMultiple: '',
  setYAxisTitleMultiple: () => {},
  inputNameBarsMultiple: '',
  setInputNameBarsMultiple: () => {},
  inputValuesColumnBars: [{ name: '', color: '#000' }],
  setInputValuesColumnBars: () => {},
  inputNameColumnGraphic: '',
  setInputNameColumnGraphic: () => {},
  xAxisTitleColumn: '',
  setXAxisTitleColumn: () => {},
  yAxisTitleColumn: '',
  setYAxisTitleColumn: () => {},
  menu: 'service',
  setMenu: () => {},
};

export const IndicatorsContext = createContext<IndicatorsContextType>(
  defaultValues
);

type IndicatorsProviderProps = {
  children: React.ReactNode;
};

export const IndicatorsProvider: React.FC<IndicatorsProviderProps> = ({
  children,
}) => {
  const [attData, setAttData] = useState<boolean>(false);

  const [elementNamesMultiple, setElementNamesMultiple] = useState<
    IndicatorBars[]
  >(
    Array(1)
      .fill(null)
      .map((_, i) => ({
        id: null,
        name: `Elemento ${i + 1}`,
        color: '#000000',
        value: 0,
      }))
  );

  const [xAxisTitleMultiple, setXAxisTitleMultiple] = useState<string>('');
  const [yAxisTitleMultiple, setYAxisTitleMultiple] = useState<string>('');
  const [inputNameBarsMultiple, setInputNameBarsMultiple] = useState<string>(
    ''
  );

  const [inputValuesColumnBars, setInputValuesColumnBars] = useState<
    ColumnBarInput[]
  >([{ name: '', color: '#000' }]);
  const [inputNameColumnGraphic, setInputNameColumnGraphic] = useState<string>(
    ''
  );
  const [xAxisTitleColumn, setXAxisTitleColumn] = useState<string>('');
  const [yAxisTitleColumn, setYAxisTitleColumn] = useState<string>('');
  const [menu, setMenu] = useState<'service' | 'work'>('service');

  const contextValue: IndicatorsContextType = {
    attData,
    setAttData,
    elementNamesMultiple,
    setElementNamesMultiple,
    xAxisTitleMultiple,
    setXAxisTitleMultiple,
    yAxisTitleMultiple,
    setYAxisTitleMultiple,
    inputNameBarsMultiple,
    setInputNameBarsMultiple,
    inputValuesColumnBars,
    setInputValuesColumnBars,
    inputNameColumnGraphic,
    setInputNameColumnGraphic,
    xAxisTitleColumn,
    setXAxisTitleColumn,
    yAxisTitleColumn,
    setYAxisTitleColumn,
    menu,
    setMenu,
  };

  return (
    <IndicatorsContext.Provider value={contextValue}>
      {children}
    </IndicatorsContext.Provider>
  );
};
